import { ReplenishmentTemplateUpdatePage } from '@/features/replenishment-template/pages/ReplenishmentTemplateUpdatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/replenishment-template/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["replenishment_template.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ReplenishmentTemplateUpdatePage,
});
